import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { useHomeGreeter } from '../../hooks/useHomeGreeter';

const GREETING_ACCENT_WIDTH = 32;

const GREETING_ACCENT_HEIGHT = 4;

const StoreHomeHeader = () => {
  const { greeting } = useHomeGreeter();
  const { translate } = useTranslation();

  return (
    <Stack spacing={1} useFlexGap>
      <Stack direction="row" spacing={2} useFlexGap sx={{ alignItems: 'center' }}>
        <Typography variant="h1" component="h1" color="text.primary">
          {greeting}
        </Typography>
        <Box
          aria-hidden
          sx={(theme) => ({
            width: GREETING_ACCENT_WIDTH,
            height: GREETING_ACCENT_HEIGHT,
            flexShrink: 0,
            borderRadius: `${theme.shape.borderRadiusFull}px`,
            backgroundColor: 'primary.main',
          })}
        />
      </Stack>
      <Typography variant="subtitle1" color="text.secondary">
        {translate(LangEnum.HOMEPAGE_STORE_SUBTITLE)}
      </Typography>
    </Stack>
  );
};

export default StoreHomeHeader;
